export type TimeFrameKey = '24h' | '7d' | '1m' | '3m' | '1y' | 'all';

type TimeFrame = {
  key: TimeFrameKey;
  name: string;
  valueDays: number;
};

export const timeFrames: Record<TimeFrameKey, TimeFrame> = {
  '24h': { key: '24h', name: '24h', valueDays: 1 },
  '7d': { key: '7d', name: '7d', valueDays: 7 },
  '1m': { key: '1m', name: '1m', valueDays: 30 },
  '3m': { key: '3m', name: '3m', valueDays: 90 },
  '1y': { key: '1y', name: '1y', valueDays: 365 },
  all: { key: 'all', name: 'All-Time', valueDays: 0 },
};
